import React from "react";

import ECD from "../components/ECD";

const Detail = (props) => {
    return (
        <div>
            <div class="container">
                <div class="row">
                    <div className="row customer-support text-center" style={{ marginTop: 10 }}>
                        <h4 style={{ color: "black" }}>{props.VehEntry.Veh_Year} {props.VehEntry.Veh_Make} {props.VehEntry.Veh_Model}</h4>
                        <p style={{ marginTop: 10, color: "black" }}>Clean-Up</p>
                        <p><b>{props.Veh_Year}</b></p>
                    </div>
                </div>
            </div>
            <div className="sec-title text-left" style={{ marginTop: 10 }}>
                <h4 style={{ color: "black" }}>What does this mean?</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>Your vehicle is being cleaned up. Our goal is to make sure your vehicle is in the same condition, or better, than when you dropped it off. This generally includes a basic wash and vacuuming of the vehicle.</p>
            </div>
            <div className="sec-title text-left">
                <h4 style={{ color: "black" }}>What is next?</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>After the vehicle is cleaned up, the vehicle will move to quality checks.</p>
            </div>
            <div className="sec-title text-left">
                <h4 style={{ color: "black" }}>Estimated Completion Date</h4>
                <span className="decor" />
                <ECD ecd={props.VehEntry.EstimatedCompletionDate} />
            </div>
        </div>
    )
}

export default Detail